var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCabChassisDefault = function SvgCabChassisDefault(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#1E242F",
    strokeWidth: 0.774,
    d: "M25.208 6.909c1.925 0 4.44-.004 6.278-.001a.382.382 0 0 0 .297-.628c-.944-1.123-2.045-2.288-3.092-2.721a.7.7 0 0 0-.149-.042c-1.341-.212-2.657-.135-3.703-.147a.397.397 0 0 0-.404.394v2.371c0 .428.346.774.773.774Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#1E242F",
    strokeLinecap: "round",
    strokeWidth: 0.774,
    d: "m9.732 14.095-2.603-.632a.774.774 0 0 1-.59-.719L6.5 11.84V7.454c0-.341.276-.617.617-.617v0c.323 0 .59.248.615.57l.175 2.272a.774.774 0 0 0 .772.714h13.218a.774.774 0 0 0 .774-.773V2.937c0-.426.344-.772.77-.774l5.187-.02q.128-.001.246.044c.536.21 2.81 1.222 5.125 4.007a.8.8 0 0 0 .554.291c.964.083 3.851.372 6.772 1.082.136.034.247.114.288.248.24.774.766 3.612-.223 5.529a.7.7 0 0 1-.514.355l-2.427.396m-22.857 0H32.9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#1E242F",
    strokeWidth: 0.8,
    d: "M13.969 14.602a1.121 1.121 0 1 1-2.243 0 1.121 1.121 0 0 1 2.242 0Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#1E242F",
    strokeWidth: 0.774,
    d: "M15.5 14.602a2.655 2.655 0 1 1-5.31 0 2.655 2.655 0 0 1 5.31 0Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#1E242F",
    strokeWidth: 0.8,
    d: "M36.806 14.771a1.121 1.121 0 1 1-2.242 0 1.121 1.121 0 0 1 2.242 0Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "#1E242F",
    strokeWidth: 0.774,
    d: "M38.34 14.77a2.655 2.655 0 1 1-5.31 0 2.655 2.655 0 0 1 5.31 0Z"
  })));
};
export default SvgCabChassisDefault;